import React from 'react';
import { motion } from 'framer-motion';

export function Section({ heading, children }) {
  return (
    <section className="border-b border-line pb-7 last:border-0">
      <h2 className="font-display text-2xl leading-snug text-ink">{heading}</h2>
      <div className="mt-3 space-y-3 text-ink-soft [&_a]:text-forest-700 [&_li]:ml-1 [&_strong]:text-ink [&_ul]:list-disc [&_ul]:space-y-1.5 [&_ul]:pl-5">
        {children}
      </div>
    </section>
  );
}

export default function LegalLayout({ eyebrow, title, intro, updated, children }) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen bg-canvas pt-24">
      <header className="border-b border-line bg-canvas-raised">
        <div className="container-fp py-12">
          {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
          <h1 className="t-h1">{title}</h1>
          {intro && <p className="t-lead mt-3 max-w-prose">{intro}</p>}
          {updated && <p className="mt-3 text-sm text-ink-soft">Last updated: {updated}</p>}
        </div>
      </header>
      <div className="container-fp py-12">
        <div className="mx-auto max-w-prose space-y-7">{children}</div>
      </div>
    </motion.div>
  );
}
